enum ModulesEnum {
  HEADER = 'header',
  FOOTER = 'footer',
  HOME = 'home',
  ABOUT_US = 'about-us',
  SERVICES = 'services',
  INDUSTRIES = 'industries',
  BLOG = 'blog',
  CONTACT = 'contact',
}

export default ModulesEnum;
